<template>
<div class="">
    <div class="content">
        <b-row>
            <el-col :span="24">
                <form @submit.prevent="submit">
                     <el-row type="flex" justify="end">
                        <!-- Node ID -->
                        <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.nodeID") }} </label></b-col>
                        <b-col cols="10"><b-form-input type="text" v-model.trim="pool.id" disabled></b-form-input></b-col>
                    </el-row>

                <el-row type="flex" justify="middle">
                    <b-col cols="2" class="right"><label class="w100 right">Speed </label></b-col>
                        <b-col cols="10">
                            <select class="form-control" v-model="maxRegs">
                                <option 
                                    v-for="option in speeds" :key="option.id" 
                                    v-bind:value="option.id"
                                    >{{ option.name }}
                                </option>
                            </select>
                        </b-col>
                </el-row>

                <el-row type="flex" justify="end" v-if="isLoading">
                    <!-- Result -->
                    <b-col cols="2" class="right"><label class="w100 right"> Progress</label></b-col>
                    <b-col cols="10">
                        <md-progress-bar v-if="this.totalRegsToLoad > 0" class="md-accent" md-mode="determinate" :md-value="(resultMBR.length / this.totalRegsToLoad)*100"></md-progress-bar>
                        {{ lastResult }}
                    </b-col>
                </el-row>
            
                <el-row type="flex" justify="end" v-if="(!showTextArea && !isLoading)">
                    <button type="submit" class="button mtop10" :disabled="isLoading">Download profile </button>
                </el-row>
                </form>
                <el-row type="flex" justify="end" v-if="showTextArea">
                        <!-- Result -->
                        <b-col cols="2" class="right"><label class="w100 right"> Result</label></b-col>
                        <b-col cols="10">
                            <b-form-textarea v-model="output" rows="10" max-rows="14"></b-form-textarea>
                            <button class="button mtop10" @click="saveFile()" >Download .cfg file </button>
                        </b-col>
                    </el-row>
            </el-col>            
        </b-row>
    </div>
</div>

</template>

<script>
import { mapState} from 'vuex'
import {required} from 'vuelidate/lib/validators';
const fb = require('../firebaseConfig.js')

export default {
    name: 'poolcomm',
    props:{
        pool:Object
    },
    data: function () {
        return {
            operation: 'RRB',
            command: null,
            lastResult: null,
            isLoading: false,
            timeout: null,
            interval: null,
            masterDoc: null,
            totalRegsToLoad: 0,
            maxRegs: 50,
            speeds:[{'id':15, 'name': '(Slow) Pools behind firewalls or limited network access'},{'id':30, 'name': '(Medium) Low RSSI signal'},{'id':50, 'name': '(Default) Normal network schema'}, ],
            globalMBR:[],
            resultMBR:[],
            totalPages:0,
            loadedPages:1,
            showTextArea:0,
            form: {
                command:null
            },
        };
    },
    validations: {
        form: {
          
        }
    },
    computed: {
        ...mapState(['currentUser']),
    },
    methods: {

        submit() {
            this.$v.form.$touch();
            if (this.$v.form.$error){
                return
            }
           this.sendCommand();
        },
        sendCommand(){
            console.log('Excecute!');
            this.isLoading = true;
            this.totalRegsToLoad  = 0;
            this.globalMBR = [];
            this.resultMBR = [];
            this.loadedPages = 1;
            fb.poolsCollection.doc(this.pool.id).get().then( res=>{
                let connect = res.data().present
                if(!connect){
                    this.poolNotConnected('Pool not present');
                }else{
                    this.getNumberOfPages();
                }
            })
        },
        
        getNumberOfPages(){
            this.lastResult = 'get number of pages, please wait \n';
            this.lastTS = Math.floor(Date.now() / 1000);
            let newOperation = {
                'ts': this.lastTS,
                'op': this.operation,
                'cmd': '',
                'user': this.currentUser.uid
            }
            fb.poolsCollection.doc(this.pool.id).collection('logs').add(newOperation).then((docRef) => { 
                this.masterDoc = docRef.id;
                this.prepareMessage(this.masterDoc, '17,1'); //Get the number of pages to read (0x0011)
                var retries = 3;
                this.interval = setInterval(()=>{  //Check the result
                    fb.poolsCollection.doc(this.pool.id).collection('logs').doc(this.masterDoc).get().then(res => {
                    let data = res.data();
                        if(data && data.result){
                            let removeOp = data.result.split(' ')
                            let arr = removeOp[1].split(':')
                            this.totalPages = parseInt(arr[1],16)
                            this.lastTS = data.ts;
                            clearInterval(this.interval);
                            
                            this.prepareMessage(this.masterDoc, '18,'+this.totalPages); //Read the total registers for page
                            this.getRegistersForPages();
                        }else{
                            if(retries-- == 0){
                                clearInterval(this.interval);
                                this.lastResult = 'No response from server, please, try again!'; 
                                this.isLoading = false;
                            }  
                        }
                     })
                    }, 1500); 
            })
        },

        getRegistersForPages(){
            var retries = 4;
            this.interval = setInterval(()=>{ 
                this.lastResult = 'get registers for total pages:'+this.totalPages+ '\n';
                fb.poolsCollection.doc(this.pool.id).collection('logs').doc(this.masterDoc).get().then(res => {
                    let data = res.data();
                    if(data && data.ts != this.lastTS){
                        let removeOp = data.result.split(' ')
                        let arr = removeOp[1].split(','); 
                        var initialreg;
                        
                        let numPages = arr.map( (val, index)=>{
                            var value;
                            if(index== 0){
                                var parts = val.split(':')
                                initialreg = parseInt(parts[0],16)
                                value = parseInt(parts[1],16)
                            }else{
                                initialreg = initialreg+ 1
                                value = parseInt(val,16)
                            }
                            this.totalRegsToLoad = this.totalRegsToLoad  + parseInt(value); //Store total registers for page
                            return value;
                        })
                        
                        clearInterval(this.interval);
                        this.lastTS = data.ts;
                        const maxPageItems = this.maxRegs;
                        const pageSize = 256 ;
                        const global = {};

                        for (var i = 0; i < numPages.length; i++) {
                        var totalPage = numPages[i]; // Total de numPages
                        var pages = Math.ceil(totalPage / maxPageItems); // Cantidad de páginas
                        global[i] = [];
                            for (var j = 0; j < pages; j++) {
                            var start = (pageSize * i );
                            const initialReg = start + j * maxPageItems;
                            const items = Math.min(maxPageItems, totalPage - j * maxPageItems);

                            const _page = {
                                start: initialReg,
                                total: items
                            };
                            global[i].push(_page);
                            }
                        }
                        this.globalMBR = [].concat(...Object.values(global));
                        this.totalPages = this.globalMBR.length;
                     

                        this.prepareMessage(this.masterDoc, this.globalMBR[0].start+','+this.globalMBR[0].total);
                        this.getDataFromPages(); //Listen pages
                    }else{
                        if(retries-- == 0){
                            clearInterval(this.interval);
                            this.lastResult = 'No response from server, please, try again!'; 
                            this.isLoading = false;
                        }
                    }
                })
            }, 2800); 
        },

        getDataFromPages(){
            var retries = 4;
            this.interval = setInterval(()=>{ 
                fb.poolsCollection.doc(this.pool.id).collection('logs').doc(this.masterDoc).get().then(res => {
                    let data = res.data();
                    let removeOp = data.result.split(' ')
                    if(data && data.ts != this.lastTS){
                        let arr = removeOp[1].split(','); 
                        var initialreg;
                        arr.map( (val, index)=>{
                            var value;
                            if(index== 0){
                                var parts = val.split(':')
                                initialreg = parseInt(parts[0],16)
                                value = parseInt(parts[1],16)
                            }else{
                                initialreg = initialreg+ 1
                                value = parseInt(val,16)
                            }
                            this.resultMBR.push('0x'+initialreg.toString(16).toUpperCase().padStart(4, '0')+':0x'+value.toString(16).padStart(2, '0').toUpperCase().padStart(4, '0'));
                            return initialreg+" = "+value
                        })
                    
                        if(this.loadedPages == this.totalPages){
                            clearInterval(this.interval);
                            this.lastResult = 'Creating file, please wait...';
                            this.isLoading = false;
                            this.getProfile();
                        } else{
                            
                            this.lastResult = 'Loaded '+this.resultMBR.length+' registers of '+this.totalRegsToLoad;

                            setTimeout(()=> {
                                this.prepareMessage(this.masterDoc, this.globalMBR[this.loadedPages].start+','+this.globalMBR[this.loadedPages].total);
                                this.lastTS = data.ts;
                                this.loadedPages = this.loadedPages +1;
                            }, 1000)
                           
        
                  
                        }
                    }else{
                        if(retries-- == 0){
                            clearInterval(this.interval);
                            this.lastResult = 'No response from server, please, try again!'; 
                            this.isLoading = false;
                        }
                    }
                })
            }, 5800); 
        },

        saveFile(){
            const blob = new Blob([this.output], { type: 'text/plain' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.pool.id+'.cfg');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        prepareMessage(operationId, command){
            this.isLoading = true
            this.$store.dispatch('sendPoolCommand', {
                'wifi': this.pool.wifi, 
                'id': this.pool.id,
                'operation': this.operation, 
                'changes': command,
                'operationId': operationId
            }).then(response => {
                //resolve({body: this.$t("messages.configRecieved"),config:{timeout:3000,closeOnClick: true}}) 
            }, error => {
                console.log('error', error);
                this.poolNotConnected(error)
            })
        },
        getProfile(){
            this.isLoading = true
            this.$store.dispatch('getPoolProfile', {
                'registers': this.resultMBR, 
            }).then(response => {
                this.isLoading = false;
                this.showTextArea = true;
                var arr = response.data.split("\n");
                this.output = arr.join('\n');
                console.log('Profile created', response);
            }, error => {
                console.log('error');
                this.poolNotConnected(error)
            })
          
        },
        poolNotConnected(msg){
            this.isLoading = false;
            this.$snotify.error( msg, {
                timeout: 3000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Poolcomm-profile.vue